import Offcanvas from 'bootstrap/js/src/offcanvas'

const OFFCANVAS_ID = '#offcanvasMenu'
const TOGGLE_SELECTOR = `[data-bs-target="${OFFCANVAS_ID}"]`

const getOffcanvasMenuElements = () => {
  const el = document.querySelector(OFFCANVAS_ID)
  return {
    el,
    instance: el ? Offcanvas.getOrCreateInstance(el) : null,
    toggleButtons: document.querySelectorAll(TOGGLE_SELECTOR)
  }
}

export const OffcanvasClickAway = () => {
  const { el, instance, toggleButtons } = getOffcanvasMenuElements()
  if (!el || !instance) return

  document.addEventListener('click', (event) => {
    const isClickInside = el.contains(event.target)
    const isToggleButton = event.target.closest('[data-bs-toggle="offcanvas"]')

    if (instance._isShown && !isClickInside && !isToggleButton) {
      instance.hide()
      toggleButtons.forEach((btn) => btn.classList.remove('open'))
    }
  })
}

export const ScrollMobileMenu = () => {
  const mobileMenu = document.querySelector('.secondary-menu')
  const classToAdd = 'scrolled'
  const headerToggleButtons = document.querySelectorAll('header .navbar-toggler')
  const { instance } = getOffcanvasMenuElements()

  if (!mobileMenu) return

  let lastScrollY = window.scrollY

  const handleScroll = () => {
    const currentScrollY = window.scrollY

    if (currentScrollY === 0 || currentScrollY < lastScrollY) {
      mobileMenu.classList.remove(classToAdd)
    } else if (currentScrollY > lastScrollY) {
      mobileMenu.classList.add(classToAdd)
      instance?.hide()
      headerToggleButtons.forEach((btn) => btn.classList.remove('open'))
    }

    lastScrollY = currentScrollY
  }

  handleScroll()
  window.addEventListener('scroll', handleScroll)
}

export const BurgerButtonToggle = () => {
  const { toggleButtons } = getOffcanvasMenuElements()
  toggleButtons.forEach((button) => {
    button.addEventListener('click', function () {
      this.classList.toggle('open')
    })
  })
}
